import { useEffect, useRef } from 'react';

import { useAppSelector } from 'application/providers/StoreProvider';
import { selectAcceptanceAdvancedError } from 'application/store/slices/acceptanceAdvancedSlice';

import { toast } from '@shared/ui';

const ACCEPTANCE_ADVANCED_ERROR_NOTIFICATION_DELAY = 5 * 60 * 1000;

export const useAcceptanceAdvancedErrorNotification = (): void => {
  const error = useAppSelector(selectAcceptanceAdvancedError());

  const shownForError = useRef<string | undefined>(undefined);

  useEffect(() => {
    if (error && shownForError.current !== error) {
      shownForError.current = error;

      toast.error(error, { duration: ACCEPTANCE_ADVANCED_ERROR_NOTIFICATION_DELAY });
    }

    if (!error) {
      shownForError.current = undefined;
    }
  }, [error]);
};
